import { FC, PropsWithChildren, useLayoutEffect } from 'react'
import { useAccount } from 'wagmi'
import { useAuth } from '../../__legacy__/hooks/useAuth'
import usePrevious from '../../__legacy__/hooks/usePrevious'
import { setServerFriendlyCookie } from '../cookies'

/**
 * Provides initial silet auth and some helpers whenever we're chaning wallet
 */
export const AuthProvider: FC<PropsWithChildren> = ({ children }) => {
  const { silentLogin, isLoggingIn, logout } = useAuth()
  const { address: walletAddress } = useAccount()
  const previousWalletAddress = usePrevious(walletAddress)

  useLayoutEffect(() => {
    if (!isLoggingIn) silentLogin()

    if (walletAddress !== undefined) {
      setServerFriendlyCookie('current_wallet', walletAddress)
    }
  }, [walletAddress])

  useLayoutEffect(() => {
    if (
      previousWalletAddress !== undefined &&
      previousWalletAddress !== walletAddress &&
      !isLoggingIn
    ) {
      // currently we are just logging out users if they try to switch accounts
      logout()
    }
  }, [walletAddress, previousWalletAddress])

  return <>{children}</>
}
